exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-00673f10] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-00673f10] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n", ""]);

// exports
